/**
 * Attribution plumbing: keep utm_* / ref params across SPA navigation and
 * remember a captured lead email so checkout can prefill Stripe + enable
 * abandoned-checkout recovery.
 */
const UTM_KEY = 'trojan_utm';
const LEAD_KEY = 'trojan_lead_email';

/** Persist utm_ and ref params from the current URL. Call on every route change. */
export function captureUtms(): void {
  try {
    const params = new URL(window.location.href).searchParams;
    const found: Record<string, string> = {};
    params.forEach((value, key) => {
      if (key.startsWith('utm_') || key === 'ref') found[key] = value;
    });
    if (Object.keys(found).length === 0) return;
    const stored = JSON.parse(sessionStorage.getItem(UTM_KEY) || '{}');
    sessionStorage.setItem(UTM_KEY, JSON.stringify({ ...stored, ...found }));
  } catch {
    // Storage unavailable (private mode etc.) — attribution is best-effort.
  }
}

/** Current-page params win over ones stored earlier in the session. */
export function getAttribution(): Record<string, string> {
  try {
    const stored = JSON.parse(sessionStorage.getItem(UTM_KEY) || '{}');
    const params = new URL(window.location.href).searchParams;
    params.forEach((value, key) => {
      if (key.startsWith('utm_') || key === 'ref') stored[key] = value;
    });
    return stored;
  } catch {
    return {};
  }
}

export function storeLeadEmail(email: string): void {
  try {
    localStorage.setItem(LEAD_KEY, email.trim().toLowerCase());
  } catch { /* best-effort */ }
}

export function getLeadEmail(): string {
  try {
    return localStorage.getItem(LEAD_KEY) || '';
  } catch {
    return '';
  }
}
